<script>
import { shuffle } from 'lodash'
import { mapState } from 'vuex'
import { emoji, businessEmoji, avatarStyles } from '~/common/avatars'

import uuid from '~/common/uuid'
import { previewPlayers } from '~/common/players'

const { FRIENDLY, BUSINESS, NONE } = avatarStyles

const animationDuration = 200

export default {
  props: {
    eventSettings: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      avatarPreviewPlayers: [],
      initializingAvatarPreviewPlayers: false,
      initializedAvatarPreviewPlayers: false
    }
  },
  computed: {
    ...mapState(['currentSlideDeck']),
    avatarStyle () {
      // Slideshow or edit mode
      const values = [
        this.eventSettings?.avatarStyle,
        this.eventToJoin?.settings?.avatarStyle,
        this.event?.settings?.avatarStyle,
        this.currentSlideDeck?.eventSettings?.avatarStyle
      ]

      let value
      for (value of values) {
        if (value !== undefined) {
          return value
        }
      }

      return null
    },
    showAvatar () {
      return [FRIENDLY, BUSINESS].includes(this.avatarStyle)
    },
    showName () {
      return this.avatarStyle !== NONE
    },
    allEmoji () {
      return shuffle(this.avatarStyle === BUSINESS ? businessEmoji : emoji)
    },
    isBusinessAvatar () {
      return this.avatarStyle === BUSINESS
    }
  },
  methods: {
    getAnonymousName () {
      return '👤'
    },
    addAvatarPreviewPlayer (name, avatar) {
      const player = {
        id: uuid(),
        name,
        avatar
      }

      this.avatarPreviewPlayers.push(player)
    },
    initAvatarPreviewPlayers () {
      if (this.initializingAvatarPreviewPlayers) {
        return
      }

      this.initializingAvatarPreviewPlayers = true
      this.avatarPreviewPlayers = []

      previewPlayers.forEach(({ name, avatar }, index) => {
        setTimeout(() => {
          this.addAvatarPreviewPlayer(
            this.avatarStyle !== NONE ? name : this.getAnonymousName(),
            this.showAvatar ? avatar[this.avatarStyle || FRIENDLY] : null
          )
          if (index === previewPlayers.length - 1) {
            this.initializingAvatarPreviewPlayers = false
            this.initializedAvatarPreviewPlayers = true
          }
        }, this.initializedAvatarPreviewPlayers ? animationDuration : index * animationDuration)
      })
    }
  }
}
</script>
